import React, { useEffect, useState } from "react";
import $ from "jquery";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Lenis from '@studio-freight/lenis'

import { LinkProvider } from './LinkProvider';

import useScrollReveal from './hooks/useScrollReveal';

import { images } from "./imagesToLoad";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Markets from "./pages/Markets";
import TradingAssets from "./pages/TradingAssets";
import Accounts from "./pages/Accounts";
import Fees from "./pages/Fees";
import Experience from "./pages/Experience";
import About from "./pages/About";
import SpecialOffers from "./pages/SpecialOffers";
import Trade from "./pages/Trade";

function App() {

    useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    return () => lenis.destroy()
  }, [])

  
  const [isLoading, setIsLoading] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      };
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    isLoading && $("body").addClass("ovf-hidden");
    Promise.all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err);
        setIsLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    !isLoading && $("body").removeClass("ovf-hidden");
    !isLoading && $("#loader").addClass("hide");
  }, [isLoading]);

  const [pass, setPass] = useState("");
  const [access, setAccess] = useState(false);

  const sendPass = () => {
    fetch("https://whoareyou.devindex.net/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pass }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result === true && data.token) {
          const expirationTime = new Date().getTime() + 60 * 60 * 1000;
          localStorage.setItem(
            "authToken",
            JSON.stringify({ token: data.token, expires: expirationTime })
          );
          setAccess(true);
        } else {
          alert("Неверный пароль");
        }
      });
  };

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem("authToken"));
    if (authData) {
      const currentTime = new Date().getTime();
      if (authData.expires > currentTime) {
        setAccess(true);
      } else {
        localStorage.removeItem("authToken");
      }
    }
  }, []);

  if (isLoading) return <div id="loader">Loading...</div>;

  if (!access) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#020202] px-[20px]">
        <div className="flex w-full max-w-[360px] flex-col gap-[20px]">
          <input
            type="password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendPass()}
            placeholder="password"
            className="h-[52px] w-full rounded-[12px] border border-[rgba(255,255,255,0.1)] bg-[rgba(255,255,255,0.05)] px-[20px] font-['Inter'] text-[16px] text-white outline-none placeholder:text-[#777] focus:border-[#ee5414]"
          />
          <button
            onClick={sendPass}
            className="h-[52px] w-full rounded-[12px] bg-[#ee5414] font-['Montserrat'] font-semibold text-[16px] text-white transition-opacity hover:opacity-90"
          >
            enter
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-x-hidden">
      <LinkProvider>
        <Router>
          <Header />
          <AnimatedRoutes />
          <Footer />
        </Router>
      </LinkProvider>
    </div>
  );
}

const pageVariants = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 },
};

const pageTransition = {
  duration: 0.5,
  ease: "easeInOut",
};

// обёртка страницы: анимация перехода + scroll-reveal секций
function PageWrap({ children }) {
  useScrollReveal();

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}

const routes = [
  { path: "/", page: <Home /> },
  { path: "/markets", page: <Markets /> },
  { path: "/trading", page: <TradingAssets /> },
  { path: "/account", page: <Accounts /> },
  { path: "/fees", page: <Fees /> },
  { path: "/education", page: <Experience /> },
  { path: "/about", page: <About /> },
  { path: "/offers", page: <SpecialOffers /> },
  { path: "/trade", page: <Trade /> },
];

// компонент для анимации переходов
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<PageWrap>{route.page}</PageWrap>}
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
}

export default App;
